const actions = {
  LOADING: 'LOADING',
  SINGLE_PROJECT_BEGIN: 'SINGLE_PROJECT_BEGIN',
  SINGLE_PROJECT_SUCCESS: 'SINGLE_PROJECT_SUCCESS',
  SINGLE_PROJECT_ERR: 'SINGLE_PROJECT_ERR',

  FILTER_PROJECT_BEGIN: 'FILTER_PROJECT_BEGIN',
  FILTER_PROJECT_SUCCESS: 'FILTER_PROJECT_SUCCESS',
  FILTER_PROJECT_ERR: 'FILTER_PROJECT_ERR',

  SORTING_PROJECT_BEGIN: 'SORTING_PROJECT_BEGIN',
  SORTING_PROJECT_SUCCESS: 'SORTING_PROJECT_SUCCESS',
  SORTING_PROJECT_ERR: 'SORTING_PROJECT_ERR',

  ASANA_ACCESS_TOKEN: 'ASANA_ACCESS_TOKEN',
  TRELLO_ACCESS_TOKEN: 'TRELLO_ACCESS_TOKEN',
  INTERCOM_ACCESS_TOKEN: 'INTERCOM_ACCESS_TOKEN',
  ELASTICSEARCH_ACCESS_TOKEN: 'ELASTICSEARCH_ACCESS_TOKEN',
  AIRTABLE_ACCESS_TOKEN: 'AIRTABLE_ACCESS_TOKEN',
  SURVEY_MONKEY_ACCESS_TOKEN: 'SURVEY_MONKEY_ACCESS_TOKEN',
  EVENTBRITE_ACCESS_TOKEN: 'EVENTBRITE_ACCESS_TOKEN',
  SPOTIFY_ACCESS_TOKEN: 'SPOTIFY_ACCESS_TOKEN',
  ADOBE_ACCESS_TOKEN: 'ADOBE_ACCESS_TOKEN',

  loading: () => {
    return {
      type: actions.LOADING,
    };
  },

  singleProjectBegin: () => {
    return {
      type: actions.SINGLE_PROJECT_BEGIN,
    };
  },

  singleProjectSuccess: (data) => {
    return {
      type: actions.SINGLE_PROJECT_SUCCESS,
      data,
    };
  },

  singleProjectErr: (err) => {
    return {
      type: actions.SINGLE_PROJECT_ERR,
      err,
    };
  },

  filterProjectBegin: () => {
    return {
      type: actions.FILTER_PROJECT_BEGIN,
    };
  },

  filterProjectSuccess: (data) => {
    return {
      type: actions.FILTER_PROJECT_SUCCESS,
      data,
    };
  },

  filterProjectErr: (err) => {
    return {
      type: actions.FILTER_PROJECT_ERR,
      err,
    };
  },

  sortingProjectBegin: () => {
    return {
      type: actions.SORTING_PROJECT_BEGIN,
    };
  },

  sortingProjectSuccess: (data) => {
    return {
      type: actions.SORTING_PROJECT_SUCCESS,
      data,
    };
  },

  sortingProjectErr: (err) => {
    return {
      type: actions.SORTING_PROJECT_ERR,
      err,
    };
  },

  // Asana
  asanaAccessToken: (data) => {
    return {
      type: actions.ASANA_ACCESS_TOKEN,
      data,
    };
  },

  // Trello
  trelloAccessToken: (data) => {
    return {
      type: actions.TRELLO_ACCESS_TOKEN,
      data,
    };
  },

  intercomAccessToken: (data) => {
    return {
      type: actions.INTERCOM_ACCESS_TOKEN,
      data,
    };
  },

  elasticsearchAccessToken: (data) => {
    return {
      type: actions.ELASTICSEARCH_ACCESS_TOKEN,
      data,
    };
  },
  airtableAccessToken: (data) => {
    return {
      type: actions.AIRTABLE_ACCESS_TOKEN,
      data,
    };
  },
  surveymonkeyAccessToken: (data) => {
    return {
      type: actions.SURVEY_MONKEY_ACCESS_TOKEN,
      data,
    };
  },
  eventbriteAccessToken: (data) => {
    return {
      type: actions.EVENTBRITE_ACCESS_TOKEN,
      data,
    };
  },
  spotifyAccessToken: (data) => {
    return {
      type: actions.SPOTIFY_ACCESS_TOKEN,
      data,
    };
  },
  adobeAccessToken: (data) => {
    return {
      type: actions.ADOBE_ACCESS_TOKEN,
      data,
    };
  },
};

export default actions;
